import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withNoIncrementalHydration } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS, withXhr } from '@angular/common/http';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { LogLevel, provideAuth, StsConfigLoader, StsConfigStaticLoader } from 'angular-auth-oidc-client';
import type { OpenIdConfiguration } from 'angular-auth-oidc-client';

import { DebugModeInterceptor } from '@app/common-codes/interceptors/debug-mode.interceptor';
import { AuthBypassInterceptor } from '@app/common-codes/interceptors/auth-bypass.interceptor';
import { RuntimeProfileService } from '@app/common-codes/services/RuntimeProfileService';

export const appConfig: ApplicationConfig = {
  providers: [
    // Le profil d'execution est lu avant tout routage : la garde et l'intercepteur en dependent.
    provideAppInitializer(() => inject(RuntimeProfileService).load()),
    provideRouter(routes),
    provideClientHydration(withNoIncrementalHydration()),
    importProvidersFrom(HttpClientModule),
    { provide: HTTP_INTERCEPTORS, useClass: DebugModeInterceptor, multi: true },
    // Doit précéder les intercepteurs qui consomment l'identité : l'en-tête de
    // contournement est posé sur la requête sortante.
    { provide: HTTP_INTERCEPTORS, useClass: AuthBypassInterceptor, multi: true },

    provideAuth({
      loader: {
        provide: StsConfigLoader,
        deps: [RuntimeProfileService],
        useFactory: (runtimeProfile: RuntimeProfileService) => {
          const auth = runtimeProfile.auth;
          if (!auth) throw new Error('Configuration d’authentification indisponible.');
          const config: OpenIdConfiguration = {
            triggerAuthorizationResultEvent: true,
            postLoginRoute: '/trucker-feature',
            forbiddenRoute: '/forbidden',
            unauthorizedRoute: '/unauthorized',
            logLevel: LogLevel.Debug,
            historyCleanupOff: false,
            authority: auth.authority,
            redirectUrl: window.location.origin + '/auth-callback',
            postLogoutRedirectUri: window.location.origin,
            clientId: auth.clientId,
            scope: auth.scope,
            responseType: 'code',
            silentRenew: false,
            useRefreshToken: true,
            renewTimeBeforeTokenExpiresInSeconds: 30,
            refreshTokenRetryInSeconds: 15,
          };
          return new StsConfigStaticLoader(config);
        },
      },
    }),

    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ]
};
